import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import EventsWrapper from 'agency/digital_renderer/components/EventsWrapper'

import ContentHolder from '../../ui/ContentHolder'
import styles from './styles.scss'

const getDatePart = (event, part) => {
  if (event.dates && event.dates.date.date){
    const date = moment(event.dates.date.date, 'DD/MM/YYYY')
    if (date && part === 'month') return date.format('MMM').toUpperCase()
    if (date && part === 'day') return date.format('DD')
  }

  return ''
}

const Timeline = ({ campaign }) => (
  <EventsWrapper
    campaign={campaign}
    render={({ events }) => (
      <div className={styles.root}>
        <ContentHolder>
          <h1>Proposed Timeline</h1>

          <ul className={styles.events}>
            {events.map(event => (
              <li key={event.id} className={styles.event}>
                <span className={styles.date}>
                  <span className={styles.month}>{getDatePart(event, 'month')}</span>
                  <span className={styles.day}>{getDatePart(event, 'day')}</span>
                </span>

                <span className={styles.title}>{event.title}</span>
              </li>
            ))}
          </ul>
        </ContentHolder>
      </div>
    )}
  />
)

Timeline.propTypes = {
  campaign: PropTypes.object.isRequired,
}

export default Timeline
